module.exports = __webpack_public_path__ + "static/media/2.9d8063fb.png";